import { Stack } from '@mui/material';

import { ContainedIconProps } from './types';

function ContainedIcon({
  size = 24,
  color = 'inherit',
  padding,
  children,
  borderRadius = 8,
  ...props
}: ContainedIconProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius: `${borderRadius}px`,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
}

export default ContainedIcon;
